export const usage = {
  title: "Usage Details",
  subtitle: "Track your token usage and costs",
  table: {
    date: "Date",
    model: "Model",
    promptTokens: "Prompt Tokens",
    completionTokens: "Completion Tokens",
    inputCost: "Input Cost",
    outputCost: "Output Cost",
    totalCost: "Total Cost",
  },
  stats: {
    subscription: {
      plan: "Plan",
      credits: "Available Credits",
      totalSpent: "Total Spent",
      status: "Status",
      nextBilling: "Next Billing",
    },
    total: {
      title: "Total Usage",
      tokens: "Total Tokens",
      cost: "Total Cost",
    },
    byModel: {
      title: "Usage by Model",
      model: "Model",
      inputTokens: "Input Tokens",
      outputTokens: "Output Tokens",
      inputCost: "Input Cost",
      outputCost: "Output Cost",
      totalCost: "Total Cost",
      inputOutputTokens: "Input / Output Tokens",
    },
    recent: {
      title: "Recent Usage",
      noTransactions: "No recent transactions",
    },
  },
  noData: "No usage data available",
  loading: "Loading usage data...",
  error: "Error loading usage data",
  refresh: "Refresh Data",
};
